import axios from "axios";

import {getTokenFromLocalStorage} from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

export const FETCH_TRANSPORTATION_REQUEST = "FETCH_TRANSPORTATION_REQUEST";
export const FETCH_TRANSPORTATION_SUCCESS = "FETCH_TRANSPORTATION_SUCCESS";
export const FETCH_TRANSPORTATION_ERROR = "FETCH_TRANSPORTATION_ERROR";
export const CLEAN_TRANSPORTATION_STATE = "CLEAN_TRANSPORTATION_STATE";

export const readTransportation = (filters = {}) => {
    return async (dispatch) => {
        try {
            dispatch(fetchTransportationRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/transports', {filters}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, fetchTransportationSuccess, fetchTransportationError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchTransportationError));
        }
    };
};

export const refreshTransportation = (client, filters = {}) => {
    return async (dispatch) => {
        try {
            const token = getTokenFromLocalStorage();
            const res = await axios.post('/api/transports/refresh', {client, filters}, { headers: { 'Authorization': 'Bearer ' + token } });
            dispatch(utilsLib.response(res, fetchTransportationSuccess, fetchTransportationError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchTransportationError));
        }
    };
};

const fetchTransportationRequest = () => {
    return {
        type: FETCH_TRANSPORTATION_REQUEST
    };
};

const fetchTransportationSuccess = (payload) => {
    return {
        type: FETCH_TRANSPORTATION_SUCCESS,
        payload
    };
};

const fetchTransportationError = (errorMessage) => {
    return {
        type: FETCH_TRANSPORTATION_ERROR,
        errorMessage
    };
};

export const cleanTransportationState = () => {
    return {
        type: CLEAN_TRANSPORTATION_STATE
    }
}
